'use strict';Object.defineProperty(exports,'__esModule',{value:true});var Logger=require('./Logger.js');exports.Logger=Logger.init;exports.init=Logger.init;